// extracted by mini-css-extract-plugin
export default {"shipment-table__wrapper":"CompletedSalesOrderTable_shipment-table__wrapper__XU0hv","shipment-table":"CompletedSalesOrderTable_shipment-table__+09A8"};